var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_1191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.889 31.834L70.8448 0.5H64.4571L41.0514 27.7068L22.3573 0.5H0.795898L29.065 41.6415L0.795898 74.5H7.18392L31.901 45.7687L51.6433 74.5H73.2047L43.8874 31.834H43.889ZM35.1397 42.004L32.2754 37.9072L9.48562 5.30879H19.2973L37.6889 31.6168L40.5532 35.7136L64.4601 69.9099H54.6485L35.1397 42.0056V42.004Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_1191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.45c775fb31e44ae6b7124e619f97cfcf.svg";
export { ForwardRef as ReactComponent };